const SORT_OPTIONS = {
    asc: 'Ascending',
    desc: 'Descending'
};

export { SORT_OPTIONS };
